// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G9lYl","title":"styles_title__3sX1t"};